import axios from 'axios'

/**
 * 获取图片资源
 * @param {string} type - 图片类型（carousel, events, hotel 等）
 * @returns {Promise} 图片数据
 */
export function getImage(type) {
    return axios({
        url: `/file/images/${type}`,
        method: 'get'
    })
}

/**
 * 获取文本资源
 * @param {string} type - 文本类型（news, travel, notification 等）
 * @returns {Promise} 文本数据
 */
export function getTxt(type) {
    return axios({
        url: `/file/texts/${type}`,
        method: 'get'
    })
}
